// #1057: the extension version the extension REPORTS (send-path log stamps, presence `app`).
//
// Dev and staging extension builds copy dev-manifest.json / staging-manifest.json, whose `version` is a
// placeholder (4.2.10), not a release. Reported as-is, the backend stored it as users.lastSeenExtensionVersion
// and both "update your extension" nudges (the server nudge and the web-app banner) fired for anyone running
// such a build. Those manifests mark themselves with `version_name` = the build channel; a marked build reports
// `<version>-<channel>`, which no version gate parses, so it is never persisted as a version and never nags.
// Store/gateway builds (manifest.json, no channel) report their real version unchanged.

/** Build channels whose manifest version is a placeholder, not a store release. */
const NON_STORE_CHANNELS = ['dev', 'staging'] as const;
type NonStoreChannel = (typeof NON_STORE_CHANNELS)[number];

function isNonStoreChannel(v: string | undefined): v is NonStoreChannel {
    return NON_STORE_CHANNELS.some((c) => c === v);
}

export function reportedExtensionVersion(
    manifest: Pick<chrome.runtime.Manifest, 'version' | 'version_name'> | undefined,
): string | undefined {
    if (!manifest) return undefined;
    return isNonStoreChannel(manifest.version_name) ? `${manifest.version}-${manifest.version_name}` : manifest.version;
}

/** The running extension's reported version; undefined outside an extension (e.g. the web app). */
export function currentReportedExtensionVersion(): string | undefined {
    try {
        return reportedExtensionVersion(globalThis.chrome?.runtime?.getManifest?.());
    } catch {
        return undefined; // a torn-down extension context throws on runtime access
    }
}
